export var useCommonDatePickerInputProps = function useCommonDatePickerInputProps(_, _ref) {
  var label = _ref.label,
    placeholder = _ref.placeholder,
    disabled = _ref.disabled,
    readOnly = _ref.readOnly,
    error = _ref.error,
    dataTestIdInput = _ref['data-testid-input'],
    inputMaskEnabled = _ref.inputMaskEnabled,
    large = _ref.large;
  return {
    inactive: disabled || readOnly,
    inputProperties: {
      readOnly: !inputMaskEnabled,
      error: error,
      disabled: disabled,
      label: label,
      placeholder: placeholder,
      enableRootRef: true,
      enableFocusOnRootClick: true,
      'data-testid-input': dataTestIdInput,
      large: large
    }
  };
};